import React from "react";

import styled from "styled-components";

const Container = styled.div`
  width: 102%;
  height: 1000px;
`;
// const mymove = styled.div`
//    background: rgb(180, 177, 177);
// `

const Ad = styled.div`
  width: 100%;
  height: 150px;
  margin-bottom: 10px;
  margin: 0 3.1% 3.1% 0;
  background: rgb(180, 177, 177);
  @keyframes mymove {
    from {
      background-color: #e6e1e1;
    }
    to {
      background-color: #c7caca;
    }
  }
  animation: mymove 1s infinite;
  border-radius: 5px;
  overflow: hidden;
  text-decoration: none;
  color: black;
  cursor: pointer;
`;
const productSkeleton = () => {
  return (
    <Container>
      <Ad />
      <Ad />
      <Ad />
      <Ad />
      <Ad />
      <Ad />
      <Ad />
      <Ad />
      <Ad />
      <Ad />
      <Ad />
      <Ad />
    </Container>
  );
};

export default productSkeleton;
